import { render, staticRenderFns } from "./order_detail.vue?vue&type=template&id=fdbb1370&scoped=true"
import script from "./order_detail.vue?vue&type=script&lang=js"
export * from "./order_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbb1370",
  null
  
)

export default component.exports